<script setup>
import { inject, computed } from 'vue'

const props = defineProps({
  mSize: { type: String, default: '' },
  active: { type: String, default: '' },
  isSummary: { type: Boolean, default: false },
  isRule: { type: Boolean, default: false }
})

const size = inject('size')
const sendPV = inject('sendPV')
const getEventID = inject('getEventID')
const isMobile = computed(() => ['s', 'xs'].includes(size.value))
const option = computed(() => {
  let arr = [
    { name: '投票列表', id: 'list' },
    { name: '投票細則', id: 'rule', hash: 'details' },
    { name: '投票走勢', id: 'trend', hash: 'trend' }
  ]
  if (!props.isSummary) arr = arr.filter((v) => v.id !== 'trend')
  if (!props.isRule) arr = arr.filter((v) => v.id !== 'rule')
  return arr
})

// 锚点跳转
const scroll2Tag = (id, behavior = 'smooth') => {
  window.scrollBy({
    top:
      document.getElementById(id).getBoundingClientRect().top -
      (isMobile.value ? 84 + 12 : 64 + 32),
    behavior
  })
}
const toAnchor = (id, hash = '', init = false) => {
  let currentHash = location.hash ? location.hash.split('#page=')?.[1] : ''
  scroll2Tag(id)
  let url = location.origin + location.pathname + location.search + (hash ? `#page=${hash}` : '')
  window.history.replaceState(history.state, null, url)
  if (currentHash !== hash || init)
    sendPV({ screenLabel: url, eventID: getEventID({ event: hash }) })
}

defineExpose({ toAnchor, scroll2Tag })
</script>

<template>
  <div class="tvb-vote-anchortag tvb-hairline--surround" :class="mSize ? 'anchortag-' + mSize : ''">
    <template v-for="item in option" :key="item.id">
      <span
        class="tvb-v-anchortag_item"
        :class="{
          'tvb-v-anchortag_active': item.id === active,
          'tvb-v-anchortag_hover': !isMobile
        }"
        @click="toAnchor('vote_' + item.id, item.hash)"
        >{{ item.name }}</span
      >
    </template>
  </div>
</template>

<style lang="scss" scoped>
.tvb-vote-anchortag {
  display: flex;
  border-radius: 8px;
  --tvb-hairline-border-radius: calc(2 * 8px);
  --tvb-hairline-border-color: rgba(255, 255, 255, 0.3) !important;
  --tvb-hairline-border-width: 2px !important;
  box-sizing: border-box;
  padding: 4px;
  // width: 100%;
  height: 36px;
  .tvb-v-anchortag_item {
    font-weight: 400;
    font-size: 15px;
    letter-spacing: 0.4px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 22px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition:
      background-color 0.15s linear,
      color 0.15s linear;
    &.tvb-v-anchortag_hover:hover {
      color: rgba(255, 255, 255, 0.9);
    }
  }
  .tvb-v-anchortag_active {
    color: rgba(255, 255, 255, 0.9);
    background-color: rgba(255, 255, 255, 0.15);
  }

  &.anchortag-xl,
  &.anchortag-l {
    height: 38px;
    // width: 266px;
    .tvb-v-anchortag_item {
      width: 86px;
    }
  }
  &.anchortag-m,
  &.anchortag-sm {
    // width: 318px;
    .tvb-v-anchortag_item {
      width: 103px;
    }
  }
  &.anchortag-mxs {
    width: 100%;
    .tvb-v-anchortag_item {
      flex: 1;
      width: 0;
    }
  }
  &.anchortag-m,
  &.anchortag-s,
  &.anchortag-sm,
  &.anchortag-mxs,
  &.anchortag-s,
  &.anchortag-xs {
    .tvb-v-anchortag_item {
      font-size: 14px;
      letter-spacing: 0.3px;
      line-height: 20px;
    }
  }
}
</style>
